export const isStorybook = import.meta.env.STORYBOOK === 'true';

const Widget = {
  DocumentsSearch: 'documents.widget.search',
  AnswerStream: 'ai_prompts.widget.context_answer_stream',
  CollectionList: 'collections.widget.list',
  Feedback: 'searches.widget.feedback',
  FeedbackReason: 'searches.widget.feedback_reason',
  IdentifyIntent: 'searchIntents.widget.identifyForSearchQuery',
  TrackError: 'trackError.widget.create',
  HelpMeta: 'searches.widget.helpmeta',
};

const Platform = {
  KeywordSearch: 'documents.search.keyword',
  DocumentsSearch: 'documents.platform.search',
  AnswerStream: 'ai_prompts.platform.answer_stream',
  CollectionList: 'collections.list',
  Feedback: 'searches.platform.feedback',
  FeedbackReason: 'searches.platform.feedback_reason',
  IdentifyIntent: '',
  HelpMeta: 'searches.platform.helpmeta',
};
const TestIntent = {
  ...(isStorybook ? Widget : Platform), // Use Widget endpoints in Storybook as Platform ones causes CORS issues
  IdentifyIntent: 'searchIntents.testActions.identifyForSearchQuery',
};

export const Endpoints = {
  Widget,
  Platform,
  TestIntent,
};
